const BASE_ALLOWED_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".pdf", ".doc", ".docx"];

const ADDITIONAL_ALLOWED_EXTENSIONS = [
  ".c",
  ".cs",
  ".cpp",
  ".html",
  ".java",
  ".json",
  ".csv",
  ".md",
  ".php",
  ".pptx",
  ".py",
  ".rb",
  ".tex",
  ".ts",
  ".txt",
  ".css",
  ".js",
  ".sh",
  ".xml",
];

export const FILE_UPLOAD_EXTENSIONS = Array.from(
  new Set([...BASE_ALLOWED_EXTENSIONS, ...ADDITIONAL_ALLOWED_EXTENSIONS])
);

export const FILE_UPLOAD_ACCEPT = FILE_UPLOAD_EXTENSIONS.join(",");
